// extracted by mini-css-extract-plugin
export default {"actionBtn":"UpdateOrder_actionBtn__58kv9","confirm":"UpdateOrder_confirm__Gx4G8","reject":"UpdateOrder_reject__Mp15Y"};